export default __webpack_public_path__ + "static/media/lung-gray.4ff14f3b.svg";